<template>
  <div class="col-md-12 col-xl-12">
    <h4 class="p-b-20">Hiring Note</h4>
    <div class="" style="">
      <input
        type="text"
        class="form-control"
        v-model="filter"
        placeholder="Search Hiring Note..."
      />
    </div>
    <div class="table-responsive">
      <datatable
        :columns="table_columns"
        :data="table_rows"
        :filter-by="filter"
      ></datatable>
    </div>

    <div class="" style="text-align: center">
      <datatable-pager
        v-model="page"
        type="long"
        :per-page="per_page"
      ></datatable-pager>
    </div>

    <div
      v-for="note in table_rows"
      v-bind:id="'note' + note.id"
      class="modal fade"
    >
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Hiring Note</h5>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p><b>Note:</b></p>
            <p v-html="note.note"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewHiringNote",
  data() {
    return {
      applicant_id: "",
      page: 1,
      per_page: 10,
      filter: "",
      table_columns: [
        {
          label: "Note",
          representedAs: (row) => {
            const note = row.note || "";
            const text = note.replace(/<[^>]*>/g, ""); 
            return text.length > 100
              ? `<span title="${text.replace(/"/g, "&quot;")}">${text.substring(
                  0,
                  100,
                )}...</span>`
              : `<span>${text}</span>`;
          },
          interpolate: true,
        },
        { label: "Evaluator", field: "evaluator_name" },
        {
          label: "Action",
          representedAs: (row) => {
            return (
              '<button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#note' +
              row.id +
              '"><i class="icofont icofont-eye"></i>View</button>'
            );
          },
          interpolate: true,
        },
      ],
      table_rows: [],
    };
  },
  methods: {
    getHiringNotes: function () {
      var note = {
        what: "GetHiringNote",
        id: this.applicant_id,
      };

      this.$socket
        .makeGetRequest(note)
        .then((response) => {
          if (response.type == "GetHiringNote") {
            this.table_rows = response.data;
            console.log(response);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.applicant_id = this.$route.params.id;
    this.getHiringNotes();
  },
};
</script>
